import { ColumnHelper } from "@tanstack/react-table";
import { ShortlistWithScores } from "PFApp/components/resource_table_toggle/hooks/use_shortlist_items";
import { Typography } from "PFComponents/typography";
import { Activity, Id } from "PFTypes";

import { ShortlistStateCell } from "./shortlist_state_cell";

type CreateShortlistStateColumnArgs = {
  headerLabel: string;
  activity: Activity;
  getStateLabel: (state: string) => string;
  onShortlistUndo?: (shortlistId: Id) => void;
};

export const createShortlistStateColumn = (
  columnHelper: ColumnHelper<ShortlistWithScores>,
  { headerLabel, activity, getStateLabel, onShortlistUndo }: CreateShortlistStateColumnArgs
) =>
  columnHelper.accessor((row) => row, {
    id: "shortlistState",
    header: () => (
      <Typography withMargin variant="labelRegular">
        {headerLabel}
      </Typography>
    ),
    cell: (info) => (
      <ShortlistStateCell activity={activity} shortlist={info.getValue()} onShortlistUndo={onShortlistUndo} />
    ),
    sortingFn: (rowA, rowB) => {
      const stateA = getStateLabel(rowA.original.state)?.toLowerCase() ?? "";
      const stateB = getStateLabel(rowB.original.state)?.toLowerCase() ?? "";
      return stateA.localeCompare(stateB);
    },
    sortUndefined: "last",
    size: 100
  });
